<template>
  <div class="row">
    <div class="col-12">
      <card>
        <div slot="header" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
          <h4 class="card-title">Client List</h4>
          <router-link v-if="$store.getters['auth/haveOneOfPermissions'](['clients/create'])"
                       :to="'/clients/create/'"
                       class="btn btn-info btn-wd" wide>
            Add New
            <span class="btn-label">
                    <i class="fa fa-plus"></i>
                </span>
          </router-link>
        </div>
        <div>
          <general-data-table
            ref="table"
            :sortable="true"
            :row-key="'id'"
            :key="componentKey"
            :api-url="'clients/index'">
            <el-table-column v-for="column in tableColumns"
                             :key="column.label"
                             :min-width="column.minWidth"
                             :align="column.align"
                             :prop="column.value"
                             :sortable="column.sortable"
                             :label="column.label">
            </el-table-column>

            <el-table-column
              :min-width="120"
              align="center"
              label="Active">
              <template slot-scope="props">

                <l-switch v-if="$store.getters['auth/haveOneOfPermissions'](['clients/change-active-status'])"
                          v-model="props.row.is_active" @input="handleActiveStatus(props.row)">
                  <i class="fa fa-check" slot="on"></i>
                  <i class="fa fa-times" slot="off"></i>
                </l-switch>

              </template>
            </el-table-column>

            <el-table-column
              :min-width="120"
              align="center"
              label="Actions">
              <template slot-scope="scope">

                <template>

                  <a v-if="$store.getters['auth/haveOneOfPermissions'](['clients/update'])"
                     v-tooltip.top-center="'Passport Download'"
                     class="btn-primary btn-simple btn-link"
                     @click="downloadPdf(scope.row)"><i class="fa fa-file-pdf"></i></a>

                  <a v-if="$store.getters['auth/haveOneOfPermissions'](['clients/update'])"
                     v-tooltip.top-center="'Qr Code'"
                     class="btn-primary btn-simple btn-link"
                     @click="openQrCodeModal(scope.row)"><i class="fa fa-eye"></i></a>

                  <router-link v-if="$store.getters['auth/haveOneOfPermissions'](['clients/update']) ||
                                     $store.getters['auth/checkAccessOwner']( scope.row.creator_id)"
                               v-tooltip.top-center="'Edit'"
                               class="btn-warning btn-simple btn-link"
                               :to="'/clients/edit/'+scope.row.id">
                    <i class="fa fa-edit"></i>
                  </router-link>

                  <a v-if="$store.getters['auth/haveOneOfPermissions'](['clients/delete']) ||
                           $store.getters['auth/checkAccessOwner'](  scope.row.creator_id)"
                     v-tooltip.top-center="'Delete'"
                     class="btn-danger btn-simple btn-link"
                     @click="openDeleteModal(scope.row.id)">
                    <i class="fa fa-times"></i></a>
                </template>


              </template>
            </el-table-column>
          </general-data-table>
        </div>
      </card>
      <delete-modal :visible="deleteModalVisibility"
                    :message="'Are you sure you want to delete this client?'"
                    @close="closeDeleteModal()"
                    @confirm="confirmDeleteModal()">
      </delete-modal>

      <qrcode-modal :visible="qrCodeModalVisibility"
                    :item="currentObject"
                    @close="closeQrCodeModal()"
      >
      </qrcode-modal>
    </div>
  </div>
</template>

<script>
import {DeleteModal as DeleteModal} from '@/components'
import GeneralDataTable from "@/components/GeneralDataTable";
import {TableColumn} from "element-ui";
import LSwitch from "../../components/Switch";
import QrcodeModal from "../../components/Modals/QrcodeModal";

export default {
  components: {
    LSwitch,
    GeneralDataTable,
    DeleteModal,
    QrcodeModal,
    [TableColumn.name]: TableColumn,
  },

  data() {

    return {
      tableColumns: [
        {label: 'Surname', value: 'surname', minWidth: '200', align: 'center'},
        {label: 'Given Names', value: 'first_name', minWidth: '200', align: 'center'},
        {label: 'Email', value: 'email', minWidth: '200', align: 'center'},
      ],
      qrCodeModalVisibility: false,
      deleteModalVisibility: false,
      currentObject: {},
      toDeleteId: undefined,
      componentKey: 0,
    }
  },
  methods: {
    handleActiveStatus(row) {
      let data = {
        'is_active': row.is_active,
      }
      this.axios.post("clients/change-active-status/" + row.id, data).then((response) => {
        this.$notify({
          message: "Client updated successfully",
          timeout: 1000,
          type: 'success'
        });
      }).catch((error) => {
        console.log(error)
      })
    },
    openDeleteModal(id) {
      this.deleteModalVisibility = true;
      this.toDeleteId = id;
    },

    closeDeleteModal() {
      this.deleteModalVisibility = false;
    },

    async confirmDeleteModal() {
      try {
        let data = {
          'id': this.toDeleteId,
        }
        await this.axios.delete("clients/delete", {headers: {}, data});
        this.$refs.table.getData("updateData");
        this.$notify({
          message: "Client deleted successfully",
          timeout: 1000,
          type: 'success'
        });
      } catch (error) {
        this.$notify({
          message: error.response.data.message,
          timeout: 2000,
          type: 'danger'
        })
      } finally {
        this.closeDeleteModal();
        this.toDeleteId = undefined;
      }
    },

    openQrCodeModal(currentObject) {
      this.currentObject = currentObject;
      this.qrCodeModalVisibility = true;
    },
    closeQrCodeModal() {
      this.qrCodeModalVisibility = false;
    },
    async downloadPdf(currentObject) {
      this.axios.get('/clients/passport-generate/' + currentObject.id, {responseType: 'arraybuffer'})
        .then((response) => {
          var file = new Blob([response.data], {type: 'application/pdf'});
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }).catch((error) => {
        if (error.response.status === 404) {
          this.$notify({
            message: "client not found",
            timeout: 2000,
            type: 'danger'
          })
        } else {
          this.$notify({
            message: "something went wrong",
            timeout: 2000,
            type: 'danger'
          })
        }

      });
    }
  },
}
</script>

